import {CP, IP} from "../setting/initParam";
import {
    centeredLine, createDefaultMaterial, CutPlane, InitialStruct,
    matBeam, ParamsGetSimpleBoard, ParamsJsonCuts, RenderElement,
    RenderStruct, simpleSize, Vec3
} from "@3dcalc/3dpClient";
import {api} from "../api/api";
import {SpecStructElement, StructData} from "@3dcalc/3dpClient/dist/types/renderElements";
import {locale} from "../setting/locale";


export async function getRidge(s:InitialStruct, sBoard:simpleSize, modeBuild: boolean = false): Promise<StructData> {

    const cut:ParamsJsonCuts = {
        gash: IP.gash.simple,
        line: CP.maps.f1.lineCut,
        plane: CutPlane.Bottom,
        width: IP.elementData.f2.sizeBoard.w
    }

    const paramsGetSimpleBoard: ParamsGetSimpleBoard = {
        modeBuild: modeBuild,
        shift: {back: s.e.back, front: s.e.front},
        sizeBoard: {w: sBoard.w, h: sBoard.h, l: sBoard.l},
        cuts: [cut,],
    }
    const rs:RenderStruct = {
        vertices: [],
        indices: [],
        uvs: [],
        material: [],
        elements: [],
        group: ''
    }
    const spec: SpecStructElement[] = []
    const specIds: string[] = []
    rs.material.push(createDefaultMaterial())
    const resultGetSimpleBoard = await api.getSimpleBoard.build(paramsGetSimpleBoard)
    rs.uvs.push(resultGetSimpleBoard.mesh.uvs)
    const numUvs = rs.uvs.length - 1
    rs.indices.push(resultGetSimpleBoard.mesh.indices)
    const numIndices = rs.indices.length - 1
    rs.vertices.push(resultGetSimpleBoard.mesh.vertices)
    const numVertices = rs.vertices.length - 1
    const nameGroup = IP.elementData.ridge.groupName || 'ridge'
    const nameElement = IP.elementData.ridge.name || 'ridge'
    rs.group = nameGroup
    const numGroups = rs.group.length
    const meta = resultGetSimpleBoard.meta

    const line = CP.maps.f1.lineCut

    const realSeg = centeredLine(CP.maps.f1.lineCut, s.l)

    const specID = nameElement
    // for (let i = 0; i < realSeg.length; i++) {
        const x = 0 - s.e.back / 2 + s.e.front / 2 //realSeg[i][0]

        const z = s.h
            - IP.gash.simple
            - IP.gash.simple
            - IP.gash.simple
            + sBoard.h / 2
            + IP.elementData.f1.sizeBoard.h
            + IP.elementData.f2.sizeBoard.l
        const pos:Vec3 = [x, z, 0]

        // const pos = updatePosY(position[i], sBoard.l / 2)

        const board: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${1}`,
            nameGroup: nameGroup,
            position: pos,
            rotation: [-Math.PI / 2, 0, Math.PI / 2,],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
            specId: specID,
        }
        rs.elements.push(board)
    // }

    spec.push({
        w: resultGetSimpleBoard.meta.w,
        h: resultGetSimpleBoard.meta.h,
        l: resultGetSimpleBoard.meta.l,
        name: nameElement,
        group: nameGroup,
        count: 1,
        materialId: IP.elementData.ridge.materialId,
        specId: specID,
    })
    specIds.push(specID)
    rs.specIds = specIds

    return {rs: rs, spec: spec}
}
